module.exports = __webpack_public_path__ + "6c4a0dbc/img/upload-icon.9179ae4e.svg";